import React from 'react';
import {HeaderOption} from '../../types';
import styles from './TableHeader.module.scss';

interface Props {
  headers: HeaderOption[];
}

export function TableHeader({headers}: Props) {
  const headerMarkup = headers.map((header) => {
    return (
      <th className={styles.Th} onClick={header.onClick}>
        {header.label}
      </th>
    );
  });
  return <thead className={styles.Thead}>{headerMarkup}</thead>;
}
